import config from "../config";
const root = config.REACT_APP_API_URL;

export const getUserRatings = () => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/ratings/myRatings`, {
      method: "GET",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          reject("Not authorized")
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};

/**
 * getMovieRatings.
 *
 * @param {} movieId
 */
export const getAllMovieRatings = (movieId) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/ratings`, {
      method: "GET",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};

/**
 * getMovieRatings.
 *
 * @param {} movieId
 */
export const getMovieRatings = (movieId) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/ratings/${movieId}`, {
      method: "GET",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          reject("Not authorized to make this request");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};

export const getMovies = (query) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/ratings?query=${query}`, {
      method: "POST",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          console.log("NOT AUTHORIZED");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};

/**
 * submitMovieRating.
 *
 * @param {number} movieId: the movie id as returned by TMDB
 * @param {boolean} liked: true, liked. false, disliked.
 */
export const submitMovieRating = (movie, rating) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");
    if (!jwt) return;
    const jwtPayload = JSON.parse(atob(jwt.split("Bearer ")[1].split(".")[1]));

    if (typeof movie.id != "number") {
      reject("Improper request types");
    }

    fetch(root + `api/ratings/${movie.id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt,
      },
      body: JSON.stringify({
        movieId: movie.id,
        movieTitle: movie.title || movie.name,
        username: jwtPayload.email,
        rating,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          console.log("NOT AUTHORIZED");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};
